import type { Locale } from '@lemonade-hq/lemonation';

export const AVAILABLE_PLACES = {
  eu: ['de', 'nl', 'fr', 'uk'],
  us: [
    'al',
    'ar',
    'ak',
    'hi',
    'az',
    'ca',
    'id',
    'ks',
    'ky',
    'co',
    'ct',
    'dc',
    'fl',
    'ga',
    'ia',
    'il',
    'la',
    'in',
    'ma',
    'me',
    'md',
    'mi',
    'mo',
    'mn',
    'ms',
    'mt',
    'nc',
    'nd',
    'ne',
    'nh',
    'nj',
    'nm',
    'nv',
    'ny',
    'oh',
    'ok',
    'or',
    'pa',
    'ri',
    'sc',
    'sd',
    'tn',
    'tx',
    'ut',
    'va',
    'vt',
    'wa',
    'wi',
    'wv',
    'wy',
    'de',
  ],
} as const;

type EuCountries = `eu.${(typeof AVAILABLE_PLACES.eu)[number]}`;
type UsStates = `us.${(typeof AVAILABLE_PLACES.us)[number]}`;

export type Countries = UsStates | EuCountries;

type CountryNames = Record<Countries, string>;
type TranslaredCountries = Record<Locale, CountryNames>;
// where us,<value> is USA state name and eu,<value> is EU country name
export const translatedCountries = {} as TranslaredCountries;

const UsaStates = {
  'us.al': 'Alabama',
  'us.ar': 'Arkansas',
  'us.ak': 'Alaska',
  'us.hi': 'Hawaii',
  'us.az': 'Arizona',
  'us.ca': 'California',
  'us.id': 'Idaho',
  'us.ks': 'Kansas',
  'us.ky': 'Kentucky',
  'us.co': 'Colorado',
  'us.ct': 'Connecticut',
  'us.dc': 'District of Columbia',
  'us.fl': 'Florida',
  'us.ga': 'Georgia',
  'us.ia': 'Iowa',
  'us.il': 'Illinois',
  'us.la': 'Louisiana',
  'us.in': 'Indiana',
  'us.ma': 'Massachusetts',
  'us.me': 'Maine',
  'us.md': 'Maryland',
  'us.mi': 'Michigan',
  'us.mo': 'Missouri',
  'us.mn': 'Minnesota',
  'us.ms': 'Mississippi',
  'us.mt': 'Montana',
  'us.nc': 'North Carolina',
  'us.nd': 'North Dakota',
  'us.ne': 'Nebraska',
  'us.nh': 'New Hampshire',
  'us.nj': 'New Jersey',
  'us.nm': 'New Mexico',
  'us.nv': 'Nevada',
  'us.ny': 'New York',
  'us.oh': 'Ohio',
  'us.ok': 'Oklahoma',
  'us.or': 'Oregon',
  'us.pa': 'Pennsylvania',
  'us.ri': 'Rhode Island',
  'us.sc': 'South Carolina',
  'us.sd': 'South Dakota',
  'us.tn': 'Tennessee',
  'us.tx': 'Texas',
  'us.ut': 'Utah',
  'us.va': 'Virginia',
  'us.vt': 'Vermont',
  'us.wa': 'Washington',
  'us.wi': 'Wisconsin',
  'us.wv': 'West Virginia',
  'us.wy': 'Wyoming',
  'us.de': 'Delaware',
} as Record<UsStates, string>;

translatedCountries['en-US'] = {
  ...UsaStates,
  'eu.de': 'Germany',
  'eu.nl': 'The Netherlands',
  'eu.fr': 'France',
  'eu.uk': 'United Kingdom',
} as CountryNames;

translatedCountries['en-DE'] = translatedCountries['en-US'];
translatedCountries['en-FR'] = translatedCountries['en-US'];
translatedCountries['en-NL'] = translatedCountries['en-US'];
translatedCountries['en-GB'] = translatedCountries['en-US'];

translatedCountries['de-DE'] = {
  ...UsaStates,
  'eu.de': 'Deutschland',
  'eu.nl': 'Niederlande',
  'eu.fr': 'Frankreich',
  'eu.uk': 'Vereinigtes Königreich',
} as CountryNames;

translatedCountries['fr-FR'] = {
  ...UsaStates,
  'eu.de': 'Allemagne',
  'eu.nl': 'Pays-Bas',
  'eu.fr': 'France',
  'eu.uk': 'Royaume-Uni',
} as CountryNames;

translatedCountries['nl-NL'] = {
  ...UsaStates,
  'eu.de': 'Duitsland',
  'eu.nl': 'Nederland',
  'eu.fr': 'Frankrijk',
  'eu.uk': 'VK',
} as CountryNames;
